/** Browser persistence: localStorage, failing soft (private mode, full quota). */

export interface KeyValueStore {
  load(key: string): string | null;
  save(key: string, value: string): void;
  remove(key: string): void;
}

export const browserStorage: KeyValueStore = {
  load(key) {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  save(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      // The game still plays; it just will not remember.
    }
  },
  remove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // As above.
    }
  },
};

/** An in-memory store for tests and `?fresh=1`. */
export function memoryStorage(): KeyValueStore {
  const map = new Map<string, string>();
  return {
    load: (key) => map.get(key) ?? null,
    save: (key, value) => void map.set(key, value),
    remove: (key) => void map.delete(key),
  };
}

export const KEYS = {
  options: 'stonefall.options',
  scores: 'stonefall.scores',
  /** The world tables as last fetched, so they show offline too. */
  worldScores: 'stonefall.scores.world',
  /** Scores made here that the server has not taken yet. */
  outbox: 'stonefall.scores.outbox',
  daily: 'stonefall.daily',
  expedition: 'stonefall.expedition',
  practice: 'stonefall.practice',
  caves: 'stonefall.caves',
  seenTitle: 'stonefall.seen',
} as const;
